const DEFAULT_MIN_WIDTH = 100
const DEFAULT_MAX_WIDTH = 520
const CELL_PADDING = 56
const ACTION_GAP = 12
const ICON_WIDTH = 20
let measureContext = null

const textWidth = (value) => {
  if (typeof document !== 'undefined') {
    if (!measureContext) measureContext = document.createElement('canvas').getContext('2d')
    if (measureContext) {
      measureContext.font = '14px "Microsoft YaHei", "PingFang SC", sans-serif'
      return Math.ceil(measureContext.measureText(String(value || '')).width)
    }
  }
  return Array.from(String(value || '')).reduce((width, char) => {
    return width + (/^[\x00-\xff]$/.test(char) ? 8 : 14)
  }, 0)
}

const actionWidth = (item) => {
  return textWidth(item.label) + (item.icon ? ICON_WIDTH : 0)
}

/**
 * 根据当前页每一行实际可见的操作，计算固定操作列所需宽度。
 * resolver 复用页面渲染操作按钮时的配置方法，保证显示内容和列宽来源一致。
 */
export const operationColumnWidth = (rows, resolver, minWidth = DEFAULT_MIN_WIDTH, maxWidth = DEFAULT_MAX_WIDTH) => {
  if (typeof resolver !== 'function') return minWidth
  const list = Array.isArray(rows) ? rows : []
  let requiredWidth = minWidth

  list.forEach(row => {
    const actions = (resolver(row) || []).filter(item => item && item.visible !== false)
    if (!actions.length) return
    const contentWidth = actions.reduce((total, item) => total + actionWidth(item), 0)
    const gapsWidth = Math.max(actions.length - 1, 0) * ACTION_GAP
    requiredWidth = Math.max(requiredWidth, contentWidth + gapsWidth + CELL_PADDING)
  })

  return Math.min(Math.ceil(requiredWidth / 10) * 12, maxWidth)
}
